import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFKitC5Svg from '@/components/UI/svg/mm100/Icon/EFKitC5Svg';
import EFKitC3SvgUs from '@/components/UI/svg/mm100/Icon/EFKitC3SvgUs';
import EFKitC3SvgAu from '@/components/UI/svg/mm100/Icon/EFKitC3SvgAu';
import EFKitC6SvgPc from '@/components/UI/svg/mm100/Icon/EFKitC6SvgPc';
import EFKitC7SvgPc from '@/components/UI/svg/mm100/Icon/EFKitC7SvgPc';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/pc/');

function ChildComp(props: any) {
    const boxClass = `base-box ${props.customClass}`;

    return (
        <div className={boxClass} style={props.customStyles}>
            <EFPic name={[props.imgSrc[0], props.imgSrc[1]]} className="fullImgs" alt={props.titleText} />
            {!!props.moreTitle ? (
                <div className="v-msg">
                    {props.titleList.map((item: string, index: number) => (
                        <div key={item} className={`v-msg-title${index + 1}`}>
                            {item}
                        </div>
                    ))}
                </div>
            ) : (
                <div className="v-msg">{props.titleText}</div>
            )}
        </div>
    );
}

export default function Comp({}: any) {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const router = useRouter();
    const { locale } = router;

    return (
        <div className={`${css.kitC} kitC`}>
            {locale === 'au' ? (
                <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1722828546824/mm100_view_au_pc.png" alt={t('presale.product.KitC_title')} />
            ) : (
                <div className="kit-box">
                    <div className="left-box">
                        <ChildComp customClass="left-top" imgSrc={['KitC1.webp', 'KitC1.jpg']} titleText={t('presale.product.KitC1_ms1')} />
                        <ChildComp
                            customClass="left-bottom"
                            imgSrc={['KitC4.webp', 'KitC4.jpg']}
                            moreTitle={true}
                            titleList={[t('presale.product.KitC4_ms1'), t('presale.product.KitC4_ms2')]}
                        />
                    </div>
                    <div className="right-box">
                        <div className="right-top">
                            <ChildComp customClass="right-top__left" imgSrc={['KitC2.webp', 'KitC2.jpg']} titleText={t('presale.product.KitC2_ms1')} />
                            <div className="right-top__right">
                                {locale !== 'au' ? (
                                    <EFKitC3SvgUs width="276px" height="54px" className="svg-class" />
                                ) : (
                                    <EFKitC3SvgAu width="276px" height="54px" className="svg-class" />
                                )}
                                <div className="title">{t('presale.product.KitC3_ms1')}</div>
                                <div className="text">{t('presale.product.KitC3_ms2')}</div>
                            </div>
                        </div>
                        <div className="right-bottom">
                            <div className="right-bottom__left">
                                <EFKitC5Svg className="kit5-svg" width="281px" height="88px" />
                                <div className="v-msg">{t('presale.product.KitC5_ms1')}</div>
                            </div>
                            <ChildComp
                                customClass="right-bottom__mid"
                                imgSrc={['KitC6.webp', 'KitC6.jpg']}
                                titleText={t('presale.product.KitC6_ms1')}
                                customStyles={{ display: locale !== 'us' ? 'block' : 'none' }}
                            />
                            <ChildComp
                                customClass="right-bottom__right"
                                imgSrc={['KitC7.webp', 'KitC7.jpg']}
                                titleText={t('presale.product.KitC7_ms1')}
                                customStyles={{ display: locale !== 'us' ? 'block' : 'none' }}
                            />
                            <div className="base-box right-bottom__mid-new" style={{ display: locale === 'us' ? 'flex' : 'none' }}>
                                <EFKitC6SvgPc width="156px" height="64px" className="kitc6-svg" />
                                <div className="v-msg-title1">{t('presale.product.KitC6_ms1_new')}</div>
                                <div className="v-msg-title2">{t('presale.product.KitC6_ms2_new')}</div>
                            </div>
                            <div className="base-box right-bottom__right-new" style={{ display: locale === 'us' ? 'flex' : 'none' }}>
                                <EFKitC7SvgPc className="kitc7-svg" />
                                <div className="v-msg v-msg-title1">{t('presale.product.KitC7_ms1_new')}</div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className="kit-text">{t('presale.product.KitC_title')}</div>
        </div>
    );
}
